import { render } from "./Title.vue?vue&type=template&id=05a6dece&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"

import "./Title.vue?vue&type=style&index=0&id=05a6dece&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05a6dece"

export default script